import { ErrorResponse } from './../../../models/error.model';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilsService } from './../../../services/utils.service';
import { AuthService } from 'src/app/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

@Component({
    selector: 'app-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrls: ['./password-reset.component.scss']
})
export class PasswordResetComponent implements OnInit {

    public environment = environment;

    showPassword = false;
    showPasswordConfirm = false;
    email: string;
    token: string;

    public passwordResetFG = new UntypedFormGroup({
        password: new UntypedFormControl('', [Validators.required]),
        passwordConfirm: new UntypedFormControl('', [Validators.required, control => this.passwordResetFG && control.value !== this.passwordResetFG.value.password ? { notEquals: true } : undefined]),
    });

    constructor(
        private authService: AuthService,
        private router: Router,
        private route: ActivatedRoute,
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
          this.email = params.email;
          this.token = params.codigoConfirmacion;
        });
    }

    resetPassword() {
        if (this.passwordResetFG.valid) {
            this.authService.changePassword(this.email, this.passwordResetFG.value.password, this.token).subscribe(
              _ => this.utilsService.alert('Contraseña cambiada correctamente', 'Ya podés iniciar sesión con tu nueva contraseña')
                .afterClosed().subscribe(() => this.router.navigate(['login'])),
                (error: ErrorResponse) => this.utilsService.alert('Error al cambiar contraseña', error.error?.descripcion)
            );
        }
    }
}
